var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TuneIcon from '@mui/icons-material/Tune';
import { Box, Paper } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { lazy, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getExtraSettingsAction } from '../../api/action/extraSettings.action';
import { getFunnelsAction, getPortalUsersAction } from '../../api/action/uspacy.action';
import { QUERY_KEY } from '../../api/types/query.type';
import { useSettings } from '../../context';
import { theme } from './theme';
var AlertComponent = lazy(function () { return import('../../components/UIcomponents/AlertComponent/AlertComponent'); });
var Loader = lazy(function () { return import('../../components/UIcomponents/Loader'); });
var ExtraSettingsForm = lazy(function () { return import('../../components/Forms/ExtraSettingsForm'); });
var Heading = lazy(function () { return import('../../components/UIcomponents/Heading'); });
var ExtraSettings = function (_a) {
    var shopId = _a.shopId;
    var t = useTranslation('settings').t;
    var _b = useSettings(), userPortal = _b.userPortal, isLoadingUserPortal = _b.isLoadingUserPortal, shopSettings = _b.shopSettings, setShopSettings = _b.setShopSettings;
    var _c = useQuery({
        queryKey: [QUERY_KEY.GET_FUNNELS, userPortal],
        queryFn: function () { return getFunnelsAction(); },
        enabled: !!userPortal && !isLoadingUserPortal && !!shopId,
    }), funnels = _c.data, isLoadingFunnels = _c.isLoading, funnelsError = _c.error, isSuccessFunnelsFetch = _c.isSuccess;
    var isFunnels = !!(funnels === null || funnels === void 0 ? void 0 : funnels.length);
    var _d = useQuery({
        queryKey: [QUERY_KEY.GET_PORTAL_USERS, userPortal],
        queryFn: function () { return getPortalUsersAction(); },
        enabled: !!userPortal && !isLoadingUserPortal && !!shopId && isSuccessFunnelsFetch,
    }), portalUsers = _d.data, isLoadingPortalUsers = _d.isLoading, portalUsersError = _d.error;
    var _e = useQuery({
        queryKey: [QUERY_KEY.GET_EXTRASETTINGS, userPortal],
        queryFn: function () { return getExtraSettingsAction(shopId); },
        enabled: !!userPortal && !isLoadingUserPortal && !!shopId && isSuccessFunnelsFetch,
    }), extraSettings = _e.data, isLoadingExtraSettings = _e.isLoading, extraSettingsError = _e.error;
    var isLoading = isLoadingFunnels || isLoadingUserPortal || isLoadingExtraSettings || isLoadingPortalUsers;
    // Update isExtraSettingsAdded based on the actual state
    useEffect(function () {
        if (isLoading)
            return;
        var isExtraSettingsConfigured = !!((extraSettings === null || extraSettings === void 0 ? void 0 : extraSettings.funnel_id) && (extraSettings === null || extraSettings === void 0 ? void 0 : extraSettings.responsible_person_id));
        setShopSettings(function (prev) { return (__assign(__assign({}, prev), { isExtraSettingsAdded: isExtraSettingsConfigured })); });
    }, [extraSettings, isLoading, setShopSettings]);
    if (isLoading) {
        return (_jsx(Paper, { sx: theme.container, children: _jsx(Loader, {}) }));
    }
    if (funnelsError) {
        return (_jsx(Paper, { sx: theme.container, children: _jsx(AlertComponent, { type: "error", message: t('extraSettings.funnels.error.getFunnels') }) }));
    }
    if (portalUsersError) {
        return (_jsx(Paper, { sx: theme.container, children: _jsx(AlertComponent, { type: "error", message: t('extraSettings.responsiblePerson.error.getPortalUsers') }) }));
    }
    if (extraSettingsError) {
        return (_jsx(Paper, { sx: theme.container, children: _jsx(AlertComponent, { type: "error", message: t('extraSettings.funnels.error.getExtraSettings') }) }));
    }
    return (_jsxs(Paper, { sx: theme.container, children: [_jsxs(Box, { sx: theme.heading, children: [_jsx(TuneIcon, { sx: shopSettings.isExtraSettingsAdded ? theme.iconCompleted : undefined }), _jsx(Heading, { title: "extraSettings.title" })] }), !isFunnels ? (_jsx(AlertComponent, { type: "warning", message: t('extraSettings.funnels.emptyFunnels') })) : (_jsx(ExtraSettingsForm, { shopId: shopId, uspacyFunnels: funnels, portalUsers: portalUsers, extraSettings: extraSettings }))] }));
};
export default ExtraSettings;
